import { applyMiddleware, createStore } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";

import rootReducer from "../reducers/index.js";

// only activate redux logger in development
const store =
  process.env.NODE_ENV === "development"
    ? createStore(
        rootReducer,
        applyMiddleware(logger, thunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__()
      )
    : createStore(rootReducer, applyMiddleware(thunk));

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js